import { render, staticRenderFns } from "./basketball-detail.vue?vue&type=template&id=5c2e5ba2&scoped=true"
import script from "./basketball-detail.vue?vue&type=script&lang=js"
export * from "./basketball-detail.vue?vue&type=script&lang=js"
import style0 from "./basketball-detail.vue?vue&type=style&index=0&id=5c2e5ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e5ba2",
  null
  
)

export default component.exports